import {
    IRetailMatchJobResult,
    IBrand,
    IRetailMatchJob,
    ISegment,
} from "../Models/Models";
import { IBrandCategory } from "../Models/IBrandCategory";
import { IGetBrandsByGeographyAndCategoriesRequest } from "../Models/Requests/IGetBrandsByGeographyAndCategoriesRequest";
import { IBrandSampleSet } from "../Models/IBrandSampleSet";
import { IGetBrandsSampleSetDataByGeoRequest } from "../Models/Requests/IGetBrandsSampleSetDataByGeoRequest";

export interface IRetailMatchAxios {
  GetResults(jobId: string): Promise<IRetailMatchJobResult>;
  GetBrandsByNaicsCode(naicsCode: string): Promise<IBrand[]>;
  GetBrandsByGeoAndCategory(
    request: IGetBrandsByGeographyAndCategoriesRequest
  ): Promise<IBrand[]>;
  UpdateJob(job: IRetailMatchJob): Promise<boolean>;
  GetMosaicSegments(): Promise<ISegment[]>;
  GetSampleSetByGeo(
    request: IGetBrandsSampleSetDataByGeoRequest
  ): Promise<IBrandSampleSet[]>;
}
